<template>
  <div id="opcion-plantilla-personalizada" v-if="acuerdo_comercial_copy">

    <v-container class="content-radio-group mb-5">
      <div class="pre-titulo mt-1">Cómo vas a crear el acuerdo: </div>
      <v-radio-group
        v-model="acuerdo_comercial_copy.seleccion_plantilla_personalizada"
        :value="acuerdo_comercial_copy.seleccion_plantilla_personalizada"
      >
        <v-radio label="Usar una plantilla" :value=0 color="accent" class="mt-1"></v-radio>
        <v-radio label="Crear personalizada" :value=1 color="accent" class="mt-2"></v-radio>
      </v-radio-group>
    </v-container>

    <!-- Si selecciona plantilla como creación -->
    <v-select
      v-if="acuerdo_comercial_copy.seleccion_plantilla_personalizada === 0"
      :items="opcionesPlantillas"
      label="Plantilla"
      placeholder="Seleccioná una plantilla"
      v-model="acuerdo_comercial_copy.plantilla"
      :rules="reglas_plantilla(acuerdo_comercial_copy.plantilla)"
      required
    />

  </div>
</template>

<script>
import { AcuerdoComercial } from '../../../models/AcuerdoComercial';

export default {
  name: 'OpcionPlantillaPersonalizada',
  props: {
    plantillas: { type: Array, default: () => [] },
    acuerdo_comercial: { type: AcuerdoComercial, default: null },
  },
  data: () => ({
    acuerdo_comercial_copy: null,
    reglas_plantilla: (valor) => [!!valor || 'Debe seleccionar una plantilla'],
  }),
  computed:{
    /**
     * Computed para preparar el select de plantillas
     */
    opcionesPlantillas(){
      return this.plantillas.map(plantilla => ({
        text: plantilla.nombre_plantilla,
        value: _.cloneDeep(plantilla),
      }));
    },
  },
  watch:{
    /**
     * Cuando selecciona personaliza, reinicio la plantilla que selecciono
     */
    'acuerdo_comercial_copy.seleccion_plantilla_personalizada'(new_value){
      if(new_value === 1){ // Personalizada
        this.acuerdo_comercial_copy.plantilla = null;
      }
    },

    /**
     * Emito evento para actualizar la plantilla seleccionada
     */
    'acuerdo_comercial_copy.plantilla'(){
      this.$emit('update:acuerdo_comercial',this.acuerdo_comercial_copy);
    },
  },
  /**
   * Al montarse el componente, se crea una copia deep del AC original, para modificarla.
   */
  mounted(){
    this.acuerdo_comercial_copy = _.cloneDeep(this.acuerdo_comercial);
  },
};
</script>

<style lang="scss">
#opcion-plantilla-personalizada{
  .content-radio-group{
    margin-top: 16px;
    border-radius: 5px;
    background-color: color(fondo-claro);
    border: 1px solid color(gris);

    .pre-titulo{
      font-size: 13px;
      color: color(dark-secund)
    }

    .v-messages.theme--light{
      display: none;
    }
  }
}
</style>